export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./by-phone-confirmation.vue?vue&type=template&id=3b94fca5"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/registration/by-phone-confirmation.vue?vue&type=template&id=3b94fca5
// module id = u4vV
// module chunks = 0